var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosingQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.03 0H139v49.265c0 18.137-3.775 32.45-11.324 42.94-7.549 10.491-20.49 19.756-38.823 27.795L75.029 93.823c11.275-5.294 19.069-10.588 23.383-15.882 4.313-5.196 6.715-11.372 7.206-18.53H75.029V0zM.47 0h63.971v49.265c0 18.137-3.774 32.45-11.323 42.94-7.55 10.491-20.49 19.756-38.824 27.795L.471 93.823c11.274-5.294 19.068-10.588 23.382-15.882 4.314-5.196 6.716-11.372 7.206-18.53H.47V0z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosingQuote);
export default __webpack_public_path__ + "static/media/closing-quote.52d3034469ccc98eb3b9fcf367a27004.svg";
export { ForwardRef as ReactComponent };